// extracted by css-extract-rspack-plugin
export default {"card":"_1Hl0I0UhOgYxfEqlUEDCzD","close":"_1mE3sSBckcsjwRwpSEEHbE","monthFilter":"_3iW55NcXOiHxjgMW2i7o-k","churnCell":"kUGZThbGdHnfJh2wUpQf","nameCell":"_3C2BGAbXPQyrkzkBgzrZ7b"};